import React from "react";

export const previewDevices = {
  phone: {
    type: "phone",
    style: {
      width: "370px",
      height: "600px",
    },
  },
  desktop: {
    type: "desktop",
    style: {
      width: "80%",
      maxWidth: "800px",
      height: "100vh",
    },
  },
};

// Make sure the shape of the default value passed to
// createContext matches the shape that the consumers expect!
export const DevicePreviewContext = React.createContext({
  previewDevice: "phone",
  toggleDevicePreview: () => {},
});
